module.exports = __webpack_public_path__ + "02f37c6f2c19597cba995e96c5db118d.svg";